import defaultClient from '@src/api/clients/default';

const URL = (path = '') => `dashboard/verticals/${path}`;

export function fetchVerticals() {
  return defaultClient.request({
    url: URL(''),
  });
}
